import React, { useState,useEffect } from 'react';
import { Button, TextField, Checkbox, FormControlLabel, FormGroup, Box, Typography, ListItemText, Autocomplete, Chip } from '@mui/material';
import { Link } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { styled } from '@mui/material/styles';
import Grid from '@mui/system/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormHelperText from '@mui/material/FormHelperText';
import axios from 'axios';
import { toast } from 'react-toastify';

const CreateItemForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    price: '',
    discount: '',
    category: '',
    brand: '',
    quantityPack: '',
    itemQuantity: '',
    unit: '',
    hsnCode: '',
    description: '',
    itemattribute: '',
    publish: false,
    showBestOffers: false,
    showEstablishedBrands: false,
    image: null,
    shelfLife: '',             
  country: '',               
  fssaiLicense: '',         
  expiryDate: '',           
  packagingType: '',       
  seller: '',                
  sellerFssai: '',          
  disclaimer: '',            
  });
  const [cate, setCate] = useState([]);
  const [brandfetch, setBrandfetch] = useState([]);


  // Fetch data when the component mounts
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/categories/allcategories`);
        const apiData = response.data;

        // console.log("Categories data:", apiData)
        setCate(apiData); 
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchCategory();
    const fetchBrand = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/brands/allbrands`); 
        const apiData = response.data; 
        // console.log("Brand data",apiData?.brands)
        setBrandfetch(apiData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchBrand();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // console.log(`Name: ${name}, Value: ${value}`);
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      image: file,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
  
    // Create FormData object
    const formDataToSend = new FormData();
    
    // Append form data for the item details
    formDataToSend.append('itemDetails[name]', formData.name);
    formDataToSend.append('itemDetails[price]', formData.price);
    formDataToSend.append('itemDetails[discount]', formData.discount);
    formDataToSend.append('itemDetails[categoryName]', formData.category);
    formDataToSend.append('itemDetails[brandName]', formData.brand);
    formDataToSend.append('itemDetails[quantityPack]', formData.quantityPack);
    formDataToSend.append('itemDetails[itemQuantity]', formData.itemQuantity);
    formDataToSend.append('itemDetails[unit]', formData.unit);
    formDataToSend.append('itemDetails[HSNCode]', formData.hsnCode);
    formDataToSend.append('itemDetails[description]', formData.description);
    formDataToSend.append('itemDetails[publish]', formData.publish);
    formDataToSend.append('itemDetails[showInBestOffer]', formData.showBestOffers);
    formDataToSend.append('itemDetails[showInEstablishedBrands]', formData.showEstablishedBrands);
    
    // Append general information
    formDataToSend.append('generalInformation[shelfLife]', formData.shelfLife);
    formDataToSend.append('generalInformation[country]', formData.country);
    formDataToSend.append('generalInformation[fssaiLicense]', formData.fssaiLicense);
    formDataToSend.append('generalInformation[expiryDate]', formData.expiryDate);
    formDataToSend.append('generalInformation[packagingType]', formData.packagingType);
    formDataToSend.append('generalInformation[seller]', formData.seller);
    formDataToSend.append('generalInformation[sellerFSSAI]', formData.sellerFssai);
    formDataToSend.append('generalInformation[disclaimer]', formData.disclaimer);
    
    // Handle item attributes (multiple values)
    // formData.itemattribute.forEach((attribute, index) => {
    //   formDataToSend.append(`itemDetails[itemattribute][${index}]`, attribute);
    // });
    
    // Append the image if selected
    if (formData.image) {
      formDataToSend.append('mediaFiles[]', formData.image);
    }
    
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/items/create`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data', // Important for file uploads
        },
      });
  
      if (response.status === 201) {
        console.log("Item created successfully!");
        toast.success(`${response.data.message}`);
  
        // Reset form data to its initial state after successful submission
        setFormData({
          name: '',
          price: '',
          discount: '',
          category: '',
          brand: '',
          quantityPack: '',
          itemQuantity: '',
          unit: '',
          hsnCode: '',
          description: '',
          itemattribute: [],
          publish: false,
          showBestOffers: false,
          showEstablishedBrands: false,
          image: null,
          shelfLife: '',
          country: '',
          fssaiLicense: '',
          expiryDate: '',
          packagingType: '',
          seller: '',
          sellerFssai: '',
          disclaimer: '',
        });
  
      }
    } catch (error) {
      console.error("Error creating item:", error);
      console.log("Failed to create item. Please try again.");
      toast.error(`Item is not Created`);
    }
  };
  
  

  return (
    <Box sx={{ maxWidth:{xs:"100%",md:'70%'}, margin:{xs:"0",md:'auto'}, padding:{xs:0,md:2}}}>
      <form onSubmit={handleSubmit}>
        <fieldset
          style={{
            border: '1px solid #ccc',
            padding: '20px',
            borderRadius: '8px',
            marginBottom: '20px',
          }}
        >
          <legend
            style={{
              padding: '8px',
              width: 'auto',
              background: '#3C7F10',
              color: '#fff',
              borderRadius: '8px',
            }}
          >
            Item Details
          </legend>
          <Box className='input-field-cls' sx={{ flexGrow: 1 }}>
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Name*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  helperText="Insert name"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Price*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  required
                  helperText="Insert Price"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Discount*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="discount"
                  value={formData.discount}
                  onChange={handleChange}
                  required
                  helperText="Insert Discount (e.g., 5%, 10%, 30%)"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Category*
                </Typography>
                <FormControl fullWidth>
                  <Select
                    labelId="category-select-label"
                    id="category-select"
                    value={formData.category || ''} 
                    onChange={handleChange}
                    name="category"
                    fullWidth
                  >
                    {cate?.categories?.map((category) => (
                      <MenuItem key={category.id} value={category.name}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormHelperText>Insert Category</FormHelperText>
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Brand*
                </Typography>
                <FormControl fullWidth>
                  <Select
                    labelId="brand-select-label"
                    id="brand-select"
                    value={formData.brand || ''}
                    onChange={handleChange}
                    name="brand"
                  >
                     {brandfetch?.brands?.map((brand) => (
                      <MenuItem key={brand.id} value={brand.title}>
                        {brand.title}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormHelperText>Insert Brand</FormHelperText>
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Quantity Pack*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="quantityPack"
                  value={formData.quantityPack}
                  onChange={handleChange}
                  required
                  helperText="Enter quantity pack (e.g. 45g, 1kg)"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Item Quantity*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="itemQuantity"
                  value={formData.itemQuantity}
                  onChange={handleChange}
                  required
                  helperText="For unlimited, set to -1"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Unit*
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="unit"
                  value={formData.unit}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  HSN Code
                </Typography>
                <TextField
                  variant="outlined"
                  fullWidth
                  name="hsnCode"
                  value={formData.hsnCode}
                  onChange={handleChange}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Item Attribute*
                </Typography>
                <Autocomplete
                  multiple
                  id="item-attribute"
                  options={['Attribute1', 'Attribute2', 'Attribute3', 'Attribute4', 'Attribute5']} // List of options
                  value={formData.itemattribute || []}  // Ensure value is an array
                  onChange={(event, newValue) => {
                    setFormData({
                      ...formData,
                      itemattribute: newValue,  // Update the array of selected items
                    });
                  }}
                  disableCloseOnSelect
                  renderInput={(params) => (
                    <TextField
                      className='multiselect-cls'
                      {...params}
                      name="itemattribute"
                      
                      helperText="Select multiple attributes"
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        key={index}
                        label={option}
                        {...getTagProps({ index })}
                        onDelete={() => {
                          // Handle chip removal
                          const updatedValue = value.filter((item) => item !== option);
                          setFormData({
                            ...formData,
                            itemattribute: updatedValue,
                          });
                        }}
                      />
                    ))
                  }
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Image
                </Typography>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ marginBottom: '10px' }}
                />
                {/* {formData.image && <Typography variant="body2">{formData.image.name}</Typography>} */}
                <Typography variant="body2" color="textSecondary" style={{ marginTop: '5px' }}>
                  Insert image
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 12 }}>
                <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                  Description*
                </Typography>
                <TextField
                  className='multiselect-cls'
                  variant="outlined"
                  fullWidth
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  multiline
                  rows={8}  // Set the number of rows for the textarea
                  required
                  helperText="Insert description"
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 12 }}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.publish}
                        onChange={handleChange}
                        name="publish"
                      />
                    }
                    label="Publish"
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.showBestOffers}
                        onChange={handleChange}
                        name="showBestOffers"
                      />
                    }
                    label="Show in Best Offers in Home Page"
                  />
                </FormGroup>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.showEstablishedBrands}
                        onChange={handleChange}
                        name="showEstablishedBrands"
                      />
                    }
                    label="Show in Established Brands in Home Page"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Box>

          
        </fieldset>
        <fieldset
  style={{
    border: '1px solid #ccc',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
  }}
>
  <legend
    style={{
      padding: '8px',
      width: 'auto',
      background: '#3C7F10',
      color: '#fff',
      borderRadius: '8px',
    }}
  >
    General Information
  </legend>
  <Box className="input-field-cls" sx={{ flexGrow: 1 }}>
    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
      {/* Existing fields */}
      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
          Shelf Life*
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          name="shelfLife"
          value={formData.shelfLife}
          onChange={handleChange}
          helperText="Insert Shelf Life"
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
      <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
  Country*
</Typography>
<FormControl fullWidth  >
  <Select
    name="country"
    value={formData.country}
    onChange={handleChange}
    id='country-dropdown'
  >
    {/* Replace these with actual country data */}
    <MenuItem value="India">India</MenuItem>
    <MenuItem value="United States">United States</MenuItem>
    <MenuItem value="Canada">Canada</MenuItem>
    <MenuItem value="United Kingdom">United Kingdom</MenuItem>
    <MenuItem value="Australia">Australia</MenuItem>
    {/* Add more countries here */}
  </Select>
  {formData.country === '' && <FormHelperText>Insert Country</FormHelperText>}
</FormControl>
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
          FSSAI License*
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          name="fssaiLicense"
          value={formData.fssaiLicense}
          onChange={handleChange}
          helperText="Insert FSSAI License"
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
      <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
    Expiry Date*
  </Typography>
  <TextField
    variant="outlined"
    fullWidth
    name="expiryDate"
    type="date"  // Use the HTML5 date input type
    value={formData.expiryDate}
    onChange={handleChange}
    helperText="Insert Expiry Date"
    InputLabelProps={{
      shrink: true,  // Ensures the label shrinks when the date picker is visible
    }}
  />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
          Packaging Type*
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          name="packagingType"
          value={formData.packagingType}
          onChange={handleChange}
          helperText="Insert Packaging Type"
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
          Seller*
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          name="seller"
          value={formData.seller}
          onChange={handleChange}
          helperText="Insert Seller"
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
          Seller FSSAI*
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          name="sellerFssai"
          value={formData.sellerFssai}
          onChange={handleChange}
          helperText="Insert Seller FSSAI"
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 12 }}>
        <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
          Disclaimer*
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          name="disclaimer"
          value={formData.disclaimer}
          onChange={handleChange}
          multiline
          rows={8}  
          className='multiselect-cls'
          helperText="Insert Disclaimer"
        />
      </Grid>

    </Grid>
  </Box>
</fieldset>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button variant="contained" sx={{ bgcolor: 'green', color: '#fff' }} type="submit">
              <SaveIcon sx={{ pr: 1 }} />
              Save
            </Button>
            <Link to="/items" style={{ textDecoration: 'none' }}>
              <Button variant="contained" sx={{ bgcolor: 'transparent', color: 'green', boxShadow: 'unset' }}>
                <SettingsBackupRestoreIcon sx={{ pr: 1 }} />
                Back
              </Button>
            </Link>
          </Box>
      </form>
    </Box>
  );
};

export default CreateItemForm;